/**
 * 创作者中心- 删除会话
 * @returns
 */
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Flex, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, SliderTrack, SliderThumb, SliderFilledTrack, Slider, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Text, Select, Input, IconButton, Textarea, Switch } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { ReactSVG } from "react-svg";
import down from "@/assets/down.svg";
import { RiColorFilterLine } from "@remixicon/react";
import { selectTrainingParams, updateTrainingParams } from "@/reducer/mymodelSlice";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const TraingHighSettingModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();
  const trainingParams = useAppSelector(selectTrainingParams);
  const [activeBtn, setActiveBtn] = useState<string>("btn1");
  const scrollRef = useRef<HTMLDivElement>(null);
  // 创建一个ref来指向锚点元素
  const anchorRef1 = useRef<HTMLDivElement>(null);
  const anchorRef2 = useRef<HTMLDivElement>(null);
  const anchorRef3 = useRef<HTMLDivElement>(null);
  const anchorRef4 = useRef<HTMLDivElement>(null);
  const anchorRef5 = useRef<HTMLDivElement>(null);
  const anchorRef6 = useRef<HTMLDivElement>(null);
  const anchorRef7 = useRef<HTMLDivElement>(null);
  const anchorRef8 = useRef<HTMLDivElement>(null);

  const [repeatVal, setRepeatVal] = useState<number>(trainingParams.repeat || 10);
  const [maxEpochsVal, setMaxEpochsVal] = useState<number>(trainingParams.max_train_epochs || 7);
  const [batchSizeVal, setBatchSizeVal] = useState<number>(trainingParams.train_batch_size || 1);
  const [saveEveryNEpochs, setSaveEveryNEpochs] = useState<number>(trainingParams.save_every_n_epochs || 2);
  const [lrWarmupSteps, setLrWarmupSteps] = useState<number>(trainingParams.lr_warmup_steps || 0);
  const [lrSchedulerNumCycles, setLrSchedulerNumCycles] = useState<number>(trainingParams.lr_scheduler_num_cycles || 1);
  const [minSnrGamma, setMinSnrGamma] = useState<number>(trainingParams.min_snr_gamma || 0);
  const [networkDim, setNetworkDim] = useState<number>(trainingParams.network_dim || 128);
  const [networkAlpha, setNetworkAlpha] = useState<number>(trainingParams.network_alpha || 64);
  const [keepTokens, setKeepTokens] = useState<number>(trainingParams.keep_tokens || 1);
  const [clipSkip, setClipSkip] = useState<number>(trainingParams.clip_skip || 2);
  const [unetLr, setUnetLr] = useState<number>(trainingParams.unet_lr);
  const [textEncoderLr, setTextEncoderLr] = useState<number>(trainingParams.text_encoder_lr);

  // 跳转到锚点的函数
  const scrollToAnchor1 = () => {
    if (scrollRef.current && anchorRef1.current) {
      anchorRef1.current.scrollIntoView({ behavior: "smooth" });
      setActiveBtn("btn1");
    }
  };
  const scrollToAnchor2 = () => {
    if (scrollRef.current && anchorRef2.current) {
      anchorRef2.current.scrollIntoView({ behavior: "smooth" });
      setActiveBtn("btn2");
    }
  };
  const scrollToAnchor3 = () => {
    if (scrollRef.current && anchorRef3.current) {
      anchorRef3.current.scrollIntoView({ behavior: "smooth" });
      setActiveBtn("btn3");
    }
  };

  const scrollToAnchor4 = () => {
    if (scrollRef.current && anchorRef4.current) {
      anchorRef4.current.scrollIntoView({ behavior: "smooth" });
      setActiveBtn("btn4");
    }
  };

  const scrollToAnchor5 = () => {
    if (scrollRef.current && anchorRef5.current) {
      anchorRef5.current.scrollIntoView({ behavior: "smooth" });
      setActiveBtn("btn5");
    }
  };

  const scrollToAnchor6 = () => {
    if (scrollRef.current && anchorRef6.current) {
      anchorRef6.current.scrollIntoView({ behavior: "smooth" });
      setActiveBtn("btn6");
    }
  };

  // const scrollToAnchor7 = () => {
  //   if (scrollRef.current && anchorRef7.current) {
  //     anchorRef7.current.scrollIntoView({ behavior: "smooth" });
  //     setActiveBtn("btn7");
  //   }
  // };

  const scrollToAnchor8 = () => {
    if (scrollRef.current && anchorRef8.current) {
      anchorRef8.current.scrollIntoView({ behavior: "smooth" });
      setActiveBtn("btn8");
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop } = scrollRef.current;
      // // 使用scrollTop的值来确定当前位置
      console.log("Current scroll position:", scrollTop);
      if (anchorRef1.current && anchorRef1.current.getBoundingClientRect().bottom < 5) {
        setActiveBtn("btn1");
      }
      if (anchorRef2.current && anchorRef2.current.getBoundingClientRect().top < 5) {
        setActiveBtn("btn2");
      }
      if (anchorRef3.current && anchorRef3.current.getBoundingClientRect().top < 5) {
        setActiveBtn("btn3");
      }
      if (anchorRef4.current && anchorRef4.current.getBoundingClientRect().top < 10) {
        setActiveBtn("btn4");
      }
      if (anchorRef5.current && anchorRef5.current.getBoundingClientRect().top < 10) {
        setActiveBtn("btn5");
      }
      if (anchorRef6.current && anchorRef6.current.getBoundingClientRect().top < 10) {
        setActiveBtn("btn6");
      }
      if (anchorRef7.current && anchorRef7.current.getBoundingClientRect().top < 10) {
        setActiveBtn("btn7");
      }
      if (anchorRef8.current && anchorRef8.current.getBoundingClientRect().top < 10) {
        setActiveBtn("btn8");
      }
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.addEventListener("scroll", handleScroll);
      return () => {
        scrollRef.current?.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const handleRandomSeed = () => {
    const min = 1000000000; // 设置最小值为10^9
    const max = 9999999999; // 设置最大值为10^10 - 1
    const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    const newParams = { ...trainingParams, seed: randomNum };
    dispatch(updateTrainingParams(newParams));
  };
  const handleRandomSampleSeed = () => {
    const min = 1000000000; // 设置最小值为10^9
    const max = 9999999999; // 设置最大值为10^10 - 1
    const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    const newParams = { ...trainingParams, sample_seed: randomNum };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeSeed = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...trainingParams, seed: Number(e.target.value) };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeSampleSeed = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...trainingParams, sample_seed: Number(e.target.value) };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeSingleTimes = (value: number) => {
    setRepeatVal(value);
    const newParams = { ...trainingParams, repeat: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeSingleTimesInput = (value: number) => {
    if (isNaN(value)) {
      setRepeatVal(1);
    } else {
      setRepeatVal(value);
    }
  };
  const handleChangeSingleTimesBlur = () => {
    const newParams = { ...trainingParams, repeat: repeatVal };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeEpochs = (value: number) => {
    setMaxEpochsVal(value);
    const newParams = { ...trainingParams, max_train_epochs: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeEpochsInput = (value: number) => {
    if (isNaN(value)) {
      setMaxEpochsVal(1);
    } else {
      setMaxEpochsVal(value);
    }
  };
  const handleChangeEpochsBlur = () => {
    const newParams = { ...trainingParams, max_train_epochs: maxEpochsVal };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeBatchSize = (value: number) => {
    setBatchSizeVal(value);
    const newParams = { ...trainingParams, train_batch_size: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeBatchSizeInput = (value: number) => {
    if (isNaN(value)) {
      setBatchSizeVal(1);
    } else {
      setBatchSizeVal(value);
    }
  };
  const handleChangeBatchSizeBlur = () => {
    const newParams = { ...trainingParams, train_batch_size: batchSizeVal };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeResolutionW = (e: React.ChangeEvent<HTMLInputElement>) => {
    let w = trainingParams.resolution.split(",");
    if (Number(e.target.value) > 1024) {
      w[0] = "1024";
    } else {
      w[0] = e.target.value;
    }
    const newParams = { ...trainingParams, resolution: w.join() };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeResolutionH = (e: React.ChangeEvent<HTMLInputElement>) => {
    let h = trainingParams.resolution.split(",");
    if (Number(e.target.value) > 1024) {
      h[1] = "1024";
    } else {
      h[1] = e.target.value;
    }
    const newParams = { ...trainingParams, resolution: h.join() };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeSaveeveryNEpochs = (value: number) => {
    setSaveEveryNEpochs(value);
    const newParams = { ...trainingParams, save_every_n_epochs: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeSaveeveryNEpochsInput = (value: number) => {
    if (isNaN(value)) {
      setSaveEveryNEpochs(1);
    } else {
      setSaveEveryNEpochs(value);
    }
  };
  const handleChangeSaveeveryNEpochsBlur = () => {
    const newParams = { ...trainingParams, save_every_n_epochs: saveEveryNEpochs };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeLrWarmupSteps = (value: number) => {
    setLrWarmupSteps(value);
    const newParams = { ...trainingParams, lr_warmup_steps: value / 100 };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeLrWarmupStepsInput = (value: number) => {
    if (isNaN(value)) {
      setLrWarmupSteps(0);
    } else {
      setLrWarmupSteps(value);
    }
  };
  const handleChangeLrWarmupStepsBlur = () => {
    const newParams = { ...trainingParams, lr_warmup_steps: lrWarmupSteps / 100 };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeLrSchedulerNumCycles = (value: number) => {
    setLrSchedulerNumCycles(value);
    const newParams = { ...trainingParams, lr_scheduler_num_cycles: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeLrSchedulerNumCyclesInput = (value: number) => {
    if (isNaN(value)) {
      setLrSchedulerNumCycles(0);
    } else {
      setLrSchedulerNumCycles(value);
    }
  };
  const handleChangeLrSchedulerNumCyclesBlur = () => {
    const newParams = { ...trainingParams, lr_scheduler_num_cycles: lrSchedulerNumCycles };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeTrainUnetOnly = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...trainingParams, network_train_unet_only: e.target.checked };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeTraintextEncoderOnly = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...trainingParams, network_train_text_encoder_only: e.target.checked };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeMinSnrGamma = (value: number) => {
    setMinSnrGamma(value);
    const newParams = { ...trainingParams, min_snr_gamma: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeMinSnrGammaInput = (value: number) => {
    if (isNaN(value)) {
      setMinSnrGamma(0);
    } else {
      setMinSnrGamma(value);
    }
  };
  const handleChangeMinSnrGammaBlur = () => {
    const newParams = { ...trainingParams, min_snr_gamma: minSnrGamma };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeEnableBlockWeights = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...trainingParams, enable_block_weights: e.target.checked };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeNetworkDim = (value: number) => {
    setNetworkDim(value);
    const newParams = { ...trainingParams, network_dim: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeNetworkDimInput = (value: number) => {
    if (isNaN(value)) {
      setNetworkDim(4);
    } else {
      setNetworkDim(value);
    }
  };
  const handleChangeNetworkDimBlur = () => {
    const newParams = { ...trainingParams, network_dim: networkDim };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeNetworkAlpha = (value: number) => {
    setNetworkAlpha(value);
    const newParams = { ...trainingParams, network_alpha: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeNetworkAlphaInput = (value: number) => {
    if (isNaN(value)) {
      setNetworkAlpha(4);
    } else {
      setNetworkAlpha(value);
    }
  };
  const handleChangeNetworkAlphaBlur = () => {
    const newParams = { ...trainingParams, network_alpha: networkAlpha };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeShuffleCaption = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...trainingParams, shuffle_caption: e.target.checked };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeWeightedCaptions = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newParams = { ...trainingParams, weighted_captions: e.target.checked };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeKeepTokens = (value: number) => {
    setKeepTokens(value);
    const newParams = { ...trainingParams, keep_tokens: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeKeepTokensInput = (value: number) => {
    if (isNaN(value)) {
      setKeepTokens(1);
    } else {
      setKeepTokens(value);
    }
  };
  const handleChangeKeepTokensBlur = () => {
    const newParams = { ...trainingParams, keep_tokens: keepTokens };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeClipSkip = (value: number) => {
    setClipSkip(value);
    const newParams = { ...trainingParams, clip_skip: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeClipSkipInput = (value: number) => {
    if (isNaN(value)) {
      setClipSkip(1);
    } else {
      setClipSkip(value);
    }
  };
  const handleChangeClipSkipBlur = () => {
    const newParams = { ...trainingParams, clip_skip: clipSkip };
    dispatch(updateTrainingParams(newParams));
  };

  const handlePrompt = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const prompt = e.target.value;
    const newParams = { ...trainingParams, prompt: prompt };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeUnetLr = () => {
    console.log(unetLr);
    if (unetLr == 0) {
      setUnetLr(0.000001);
      dispatch(
        updateTrainingParams({
          ...trainingParams,
          unet_lr: 0.000001,
        })
      );
    } else if (unetLr > 0.001) {
      setUnetLr(0.001);
      dispatch(
        updateTrainingParams({
          ...trainingParams,
          unet_lr: 0.001,
        })
      );
    } else {
      dispatch(
        updateTrainingParams({
          ...trainingParams,
          unet_lr: unetLr,
        })
      );
    }
  };

  const handleChangeTextEncoderLr = () => {
    if (textEncoderLr == 0) {
      setTextEncoderLr(0.000001);
      dispatch(
        updateTrainingParams({
          ...trainingParams,
          text_encoder_lr: 0.000001,
        })
      );
    } else if (textEncoderLr > 0.001) {
      setTextEncoderLr(0.001);
      dispatch(
        updateTrainingParams({
          ...trainingParams,
          text_encoder_lr: 0.001,
        })
      );
    } else {
      dispatch(
        updateTrainingParams({
          ...trainingParams,
          text_encoder_lr: textEncoderLr,
        })
      );
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg="#fff" h="60vh">
        <ModalHeader color="#27314D" fontSize={"18px"}>
          高级设置
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody pl={0} pb={6} borderTop="1px solid #8E94A9">
          <Flex h="100%">
            <Box mr={"10px"}>
              <Button display={"block"} w="194px" h="50px" bg={activeBtn === "btn1" ? "#EEF1F7" : "none"} borderLeft={activeBtn === "btn1" ? "10px solid #496AE1" : "0px solid #fff"} color={activeBtn === "btn1" ? "#27314D" : "#8E94A9"} borderRadius={0} fontWeight="normal" _hover={{ bg: "#EEF1F7", color: "#27314D" }} onClick={scrollToAnchor1}>
                训练参数
              </Button>
              <Button display={"block"} w="194px" h="50px" bg={activeBtn === "btn2" ? "#EEF1F7" : "none"} borderLeft={activeBtn === "btn2" ? "10px solid #496AE1" : "0px solid #fff"} color={activeBtn === "btn2" ? "#27314D" : "#8E94A9"} borderRadius={0} fontWeight="normal" _hover={{ bg: "#EEF1F7", color: "#27314D" }} onClick={scrollToAnchor2}>
                样图设置
              </Button>
              <Button display={"block"} w="194px" h="50px" bg={activeBtn === "btn3" ? "#EEF1F7" : "none"} borderLeft={activeBtn === "btn3" ? "10px solid #496AE1" : "0px solid #fff"} color={activeBtn === "btn3" ? "#27314D" : "#8E94A9"} borderRadius={0} fontWeight="normal" _hover={{ bg: "#EEF1F7", color: "#27314D" }} onClick={scrollToAnchor3}>
                保存设置
              </Button>
              <Button display={"block"} w="194px" h="50px" bg={activeBtn === "btn4" ? "#EEF1F7" : "none"} borderLeft={activeBtn === "btn4" ? "10px solid #496AE1" : "0px solid #fff"} color={activeBtn === "btn4" ? "#27314D" : "#8E94A9"} borderRadius={0} fontWeight="normal" _hover={{ bg: "#EEF1F7", color: "#27314D" }} onClick={scrollToAnchor4}>
                学习率&优化器
              </Button>
              <Button display={"block"} w="194px" h="50px" bg={activeBtn === "btn5" ? "#EEF1F7" : "none"} borderLeft={activeBtn === "btn5" ? "10px solid #496AE1" : "0px solid #fff"} color={activeBtn === "btn5" ? "#27314D" : "#8E94A9"} borderRadius={0} fontWeight="normal" _hover={{ bg: "#EEF1F7", color: "#27314D" }} onClick={scrollToAnchor5}>
                网络
              </Button>
              <Button display={"block"} w="194px" h="50px" bg={activeBtn === "btn6" ? "#EEF1F7" : "none"} borderLeft={activeBtn === "btn6" ? "10px solid #496AE1" : "0px solid #fff"} color={activeBtn === "btn6" ? "#27314D" : "#8E94A9"} borderRadius={0} fontWeight="normal" _hover={{ bg: "#EEF1F7", color: "#27314D" }} onClick={scrollToAnchor6}>
                打标设置
              </Button>
              {/* <Button
                display={"block"}
                w="194px"
                h="50px"
                bg={activeBtn === "btn7" ? "#EEF1F7" : "none"}
                borderLeft={
                  activeBtn === "btn7" ? "10px solid #496AE1" : "0px solid #fff"
                }
                color={activeBtn === "btn7" ? "#27314D" : "#8E94A9"}
                borderRadius={0}
                fontWeight="normal"
                _hover={{ bg: "#EEF1F7", color: "#27314D" }}
                onClick={scrollToAnchor7}
              >
                噪声设置
              </Button> */}
              <Button display={"block"} w="194px" h="50px" bg={activeBtn === "btn8" ? "#EEF1F7" : "none"} borderLeft={activeBtn === "btn8" ? "10px solid #496AE1" : "0px solid #fff"} color={activeBtn === "btn8" ? "#27314D" : "#8E94A9"} borderRadius={0} fontWeight="normal" _hover={{ bg: "#EEF1F7", color: "#27314D" }} onClick={scrollToAnchor8}>
                其他设置
              </Button>
            </Box>
            {/* 右侧 */}
            <Box flex={1} h="100%" overflow={"auto"} pr="15px" ref={scrollRef}>
              <Box ref={anchorRef1} pb="20px">
                <Box mb="20px" fontSize={"24px"} color="#27314D" fontWeight={500}>
                  训练参数
                </Box>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Repeat
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        单张训练次数
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.repeat} step={1} min={1} max={50} onChange={handleChangeSingleTimes}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={50} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={repeatVal} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeSingleTimesInput(valueAsNumber)} onBlur={handleChangeSingleTimesBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Epoch
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        训练轮数
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.max_train_epochs} step={1} min={1} max={20} onChange={handleChangeEpochs}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={20} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={maxEpochsVal} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeEpochsInput(valueAsNumber)} onBlur={handleChangeEpochsBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Batch size
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        批量大小
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.train_batch_size} step={1} min={1} max={20} onChange={handleChangeBatchSize}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={20} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={batchSizeVal} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeBatchSizeInput(valueAsNumber)} onBlur={handleChangeBatchSizeBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Mixed precision
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      训练混合精度
                    </Text>
                  </Box>
                  <Select
                    icon={<ReactSVG src={down} />}
                    variant="Unstyled"
                    flex={1}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    borderRadius={0}
                    fontSize="14px"
                    color={"#27314D"}
                    value={trainingParams.mixed_precision}
                    onChange={(e) => {
                      dispatch(
                        updateTrainingParams({
                          ...trainingParams,
                          mixed_precision: e.target.value,
                        })
                      );
                    }}
                  >
                    <option value="no">no</option>
                    <option value="fp16">fp16</option>
                    <option value="bf16">bf16</option>
                  </Select>
                </Flex>
              </Box>
              <Box ref={anchorRef2} pb="20px">
                <Box mb="20px" fontSize={"24px"} color="#27314D" fontWeight={500}>
                  样图设置
                </Box>

                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      resolution
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      样图分辨率
                    </Text>
                  </Box>
                  <Flex flex={1} alignItems={"center"}>
                    <Input
                      flex={1}
                      borderRadius={0}
                      bgColor="#EEF1F7"
                      h="40px"
                      type="number"
                      border={"none"}
                      fontSize="14px"
                      color={"#27314D"}
                      focusBorderColor="transparent"
                      _focus={{
                        borderColor: "transparent",
                      }}
                      value={trainingParams.resolution.split(",")[0]}
                      onChange={handleChangeResolutionW}
                    />
                    <Box color={"#8E94A9"} bgColor="#EEF1F7" h="40px" pl="10px" pr="10px" lineHeight={"40px"}>
                      width
                    </Box>
                    <Box width={"100px"} textAlign="center" fontSize={"15px"} color="#27314D">
                      *
                    </Box>
                    <Input
                      flex={1}
                      placeholder=""
                      borderRadius={0}
                      bgColor="#EEF1F7"
                      h="40px"
                      type="number"
                      border={"none"}
                      fontSize="14px"
                      color={"#27314D"}
                      focusBorderColor="transparent"
                      _focus={{
                        borderColor: "transparent",
                      }}
                      value={trainingParams.resolution.split(",")[1]}
                      onChange={handleChangeResolutionH}
                    />
                    <Box color={"#8E94A9"} bgColor="#EEF1F7" h="40px" pl="10px" pr="10px" lineHeight={"40px"}>
                      height
                    </Box>
                  </Flex>
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      seed
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      随机种子数
                    </Text>
                  </Box>
                  <Input flex={1} type="number" borderRadius={0} bgColor="#EEF1F7" h="40px" border={"none"} fontSize="14px" color={"#27314D"} value={trainingParams.sample_seed} onChange={handleChangeSampleSeed} />
                  <IconButton aria-label="seed" ml="20px" bg="#EEF1F7" icon={<RiColorFilterLine size={"16px"} color={"#27314D"} />} onClick={handleRandomSampleSeed} />
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Sampler
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      采样方式
                    </Text>
                  </Box>
                  <Select
                    icon={<ReactSVG src={down} />}
                    variant="Unstyled"
                    flex={1}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    borderRadius={0}
                    fontSize="14px"
                    color={"#27314D"}
                    value={trainingParams.sample_sampler}
                    onChange={(e) => {
                      dispatch(
                        updateTrainingParams({
                          ...trainingParams,
                          sample_sampler: e.target.value,
                        })
                      );
                    }}
                  >
                    <option value="ddim">ddim</option>
                    <option value="pndm">pndm</option>
                    <option value="lms">lms</option>
                    <option value="euler">euler</option>
                    <option value="euler_a">euler_a</option>
                    <option value="heun">heun</option>
                    <option value="dpm_2">dpm_2</option>
                    <option value="dpm_2_a">dpm_2_a</option>
                    <option value="dpmsolver++">dpmsolver++</option>
                    <option value="dpmsingle">dpmsingle</option>
                    <option value="k_lms">k_lms</option>
                    <option value="k_euler">k_euler</option>
                    <option value="k_euler_a">k_euler_a</option>
                    <option value="k_dpm_2">k_dpm_2</option>
                    <option value="k_dpm_2_a">k_dpm_2_a</option>
                  </Select>
                </Flex>
                <Flex mb={"20px"} alignItems="top">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Prompts
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      提示词
                    </Text>
                  </Box>
                  <Textarea flex={1} placeholder="请输入提示词" borderRadius={0} bgColor="#EEF1F7" lineHeight={"25px"} border={"none"} fontSize="14px" color={"#27314D"} rows={3} value={trainingParams.prompt} onChange={handlePrompt} />
                </Flex>
              </Box>
              <Box ref={anchorRef3}>
                <Box mb="20px" fontSize={"24px"} color="#27314D" fontWeight={500}>
                  保存设置
                </Box>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Save every N epochs
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        每N轮保存一个LoRA
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.save_every_n_epochs} step={1} min={1} max={8} onChange={handleChangeSaveeveryNEpochs}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={8} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={saveEveryNEpochs} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeSaveeveryNEpochsInput(valueAsNumber)} onBlur={handleChangeSaveeveryNEpochsBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Save precision
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      LoRA保存精度
                    </Text>
                  </Box>
                  <Select
                    icon={<ReactSVG src={down} />}
                    variant="Unstyled"
                    flex={1}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    borderRadius={0}
                    fontSize="14px"
                    color={"#27314D"}
                    value={trainingParams.save_precision}
                    onChange={(e) => {
                      dispatch(
                        updateTrainingParams({
                          ...trainingParams,
                          save_precision: e.target.value,
                        })
                      );
                    }}
                  >
                    <option value="float">float</option>
                    <option value="fp16">fp16</option>
                    <option value="bf16">bf16</option>
                  </Select>
                </Flex>
              </Box>
              <Box ref={anchorRef4}>
                <Box mb="20px" fontSize={"24px"} color="#27314D" fontWeight={500}>
                  学习&优化器
                </Box>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Learning Rate
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      总学习率
                    </Text>
                    <Text fontSize={"10px"} color={"#8E94A9"}>
                      分开设置 unet 和 text encoder 学习率后这个值失效
                    </Text>
                  </Box>
                  <Select
                    icon={<ReactSVG src={down} />}
                    variant="Unstyled"
                    flex={1}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    borderRadius={0}
                    fontSize="14px"
                    color={"#27314D"}
                    value={trainingParams.learning_rate}
                    onChange={(e) => {
                      dispatch(
                        updateTrainingParams({
                          ...trainingParams,
                          learning_rate: Number(e.target.value),
                        })
                      );
                    }}
                  >
                    <option value="0.000001">1e-6</option>
                    <option value="0.00001">1e-5</option>
                    <option value="0.00005">5e-5</option>
                    <option value="0.0001">1e-4</option>
                    <option value="0.0002">2e-4</option>
                  </Select>
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Unet lr
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      Unet学习率
                    </Text>
                  </Box>
                  <Input
                    flex={1}
                    type="number"
                    placeholder=""
                    borderRadius={0}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    fontSize="14px"
                    color={"#27314D"}
                    value={unetLr}
                    onBlur={handleChangeUnetLr}
                    onChange={(e) => {
                      setUnetLr(Number(e.target.value));
                      // dispatch(
                      //   updateTrainingParams({
                      //     ...trainingParams,
                      //     unet_lr: Number(e.target.value),
                      //   })
                      // );
                    }}
                  />
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Text encoder lr
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      文本编码器学习率
                    </Text>
                  </Box>
                  <Input
                    flex={1}
                    type="number"
                    placeholder=""
                    borderRadius={0}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    fontSize="14px"
                    color={"#27314D"}
                    value={textEncoderLr}
                    onChange={(e) => {
                      setTextEncoderLr(Number(e.target.value));
                    }}
                    onBlur={handleChangeTextEncoderLr}
                  />
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Lr warm up
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        学习率预热（%）
                      </Text>
                    </Box>
                    <Slider flex={1} value={Math.floor(trainingParams.lr_warmup_steps * 100)} step={1} min={0} max={100} onChange={handleChangeLrWarmupSteps}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={100} min={0} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={lrWarmupSteps} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeLrWarmupStepsInput(valueAsNumber)} onBlur={handleChangeLrWarmupStepsBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Lr scheduler
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      学习率调度器
                    </Text>
                  </Box>
                  <Select
                    icon={<ReactSVG src={down} />}
                    variant="Unstyled"
                    flex={1}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    borderRadius={0}
                    fontSize="14px"
                    color={"#27314D"}
                    value={trainingParams.lr_scheduler}
                    onChange={(e) => {
                      dispatch(
                        updateTrainingParams({
                          ...trainingParams,
                          lr_scheduler: e.target.value,
                        })
                      );
                    }}
                  >
                    <option value="linear">linear</option>
                    <option value="cosine">cosine</option>
                    <option value="cosine_with_restarts">cosine_with_restarts</option>
                    <option value="polynomial">polynomial</option>
                    <option value="constant">constant</option>
                    <option value="constant_with_wramup">constant_with_wramup</option>
                  </Select>
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Optimizer
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      优化器
                    </Text>
                  </Box>
                  <Select
                    icon={<ReactSVG src={down} />}
                    variant="Unstyled"
                    flex={1}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    borderRadius={0}
                    fontSize="14px"
                    color={"#27314D"}
                    value={trainingParams.optimizer_type}
                    onChange={(e) => {
                      dispatch(
                        updateTrainingParams({
                          ...trainingParams,
                          optimizer_type: e.target.value,
                        })
                      );
                    }}
                  >
                    <option value="AdamW8bit">AdamW8bit</option>
                    <option value="Lion">Lion</option>
                    <option value="Prodigy">Prodigy（仅支持设置总学习率，建议1.0）</option>
                  </Select>
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Lr scheduler num cycles
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        重启次数
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.lr_scheduler_num_cycles} step={1} min={1} max={5} onChange={handleChangeLrSchedulerNumCycles}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={5} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={lrSchedulerNumCycles} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeLrSchedulerNumCyclesInput(valueAsNumber)} onBlur={handleChangeLrSchedulerNumCyclesBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Train unet only
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      仅训练Unet
                    </Text>
                  </Box>
                  <Switch isDisabled={trainingParams.network_train_text_encoder_only} isChecked={trainingParams.network_train_unet_only} onChange={handleChangeTrainUnetOnly} />
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Train text encoder only
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      仅训练文本编码器
                    </Text>
                  </Box>
                  <Switch isDisabled={trainingParams.network_train_unet_only} isChecked={trainingParams.network_train_text_encoder_only} onChange={handleChangeTraintextEncoderOnly} />
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Min snr gamma
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        最小信噪比伽马值
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.min_snr_gamma} step={1} min={0} max={20} onChange={handleChangeMinSnrGamma}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={20} min={0} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={minSnrGamma} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeMinSnrGammaInput(valueAsNumber)} onBlur={handleChangeMinSnrGammaBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
              </Box>
              <Box ref={anchorRef5}>
                <Box mb="20px" fontSize={"24px"} color="#27314D" fontWeight={500}>
                  网络
                </Box>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      enable block weights
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      启用分层学习率训练
                    </Text>
                  </Box>
                  <Switch isChecked={trainingParams.enable_block_weights} onChange={handleChangeEnableBlockWeights} />
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Network Rank Dim
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        网络大小
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.network_dim} step={1} min={4} max={1024} onChange={handleChangeNetworkDim}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={1024} min={4} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={networkDim} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeNetworkDimInput(valueAsNumber)} onBlur={handleChangeNetworkDimBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Network Alpha
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        网络Alpha
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.network_alpha} step={1} min={4} max={1024} onChange={handleChangeNetworkAlpha}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={1024} min={4} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={networkAlpha} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeNetworkAlphaInput(valueAsNumber)} onBlur={handleChangeNetworkAlphaBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
              </Box>
              <Box ref={anchorRef6}>
                <Box mb="20px" fontSize={"24px"} color="#27314D" fontWeight={500}>
                  打标设置
                </Box>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Shuffle caption
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      打乱标注
                    </Text>
                  </Box>
                  <Switch isChecked={trainingParams.shuffle_caption} onChange={handleChangeShuffleCaption} />
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      weighted captions
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      使用带权重的token
                    </Text>
                  </Box>
                  <Switch isChecked={trainingParams.weighted_captions} onChange={handleChangeWeightedCaptions} />
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        keep n tokens
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        保持n个token
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.keep_tokens} step={1} min={0} max={225} onChange={handleChangeKeepTokens}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={225} min={0} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={keepTokens} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeKeepTokensInput(valueAsNumber)} onBlur={handleChangeKeepTokensBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      Max token length
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      最大token长度
                    </Text>
                  </Box>
                  <Select
                    icon={<ReactSVG src={down} />}
                    variant="Unstyled"
                    flex={1}
                    bgColor="#EEF1F7"
                    h="40px"
                    border={"none"}
                    borderRadius={0}
                    fontSize="14px"
                    color={"#27314D"}
                    value={trainingParams.max_token_length}
                    onChange={(e) => {
                      dispatch(
                        updateTrainingParams({
                          ...trainingParams,
                          max_token_length: Number(e.target.value),
                        })
                      );
                    }}
                  >
                    <option value="75">75</option>
                    <option value="150">150</option>
                    <option value="225">225</option>
                  </Select>
                </Flex>
              </Box>
              {/* <Box ref={anchorRef7}>
                <Box
                  mb="20px"
                  fontSize={"24px"}
                  color="#27314D"
                  fontWeight={500}
                >
                  噪声设置
                </Box>
                <Flex
                  mb={"20px"}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Noise offset（0~1）
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        噪声偏移
                      </Text>
                      <Text fontSize={"10px"} color={"#8E94A9"}>
                        设置金字塔噪声后这个值失效
                      </Text>
                    </Box>
                    <Slider
                      flex={1}
                      // value={trainingParams.single_times}
                      step={0.01}
                      min={0}
                      max={1}
                      // onChange={handleChangeSingleTimes}
                    >
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput
                    h="40px"
                    w="100px"
                    step={0.01}
                    max={1}
                    min={0}
                    size="xs"
                    borderRadius={0}
                    bgColor="#EEF1F7"
                    border={"none"}
                    fontSize="14px"
                    color={"#27314D"}
                    // value={trainingParams.single_times}
                    textAlign="center"
                    p={0}
                    // onChange={(
                    //   valueAsString: string,
                    //   valueAsNumber: number
                    // ) => handleChangeSingleTimes(valueAsNumber)}
                  >
                    <NumberInputField
                      border={"none"}
                      pr="14px"
                      h="100%"
                      borderRadius={0}
                    />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper
                        border={"none"}
                        fontSize={"10px"}
                      />
                      <NumberDecrementStepper
                        border={"none"}
                        fontSize={"10px"}
                      />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex
                  mb={"20px"}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Multires noise iterations
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        多分辨率（金字塔）噪声扩散次数
                      </Text>
                    </Box>
                    <Slider
                      flex={1}
                      // value={trainingParams.single_times}
                      step={1}
                      min={0}
                      max={64}
                      // onChange={handleChangeSingleTimes}
                    >
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput
                    h="40px"
                    w="100px"
                    step={1}
                    max={64}
                    min={0}
                    size="xs"
                    borderRadius={0}
                    bgColor="#EEF1F7"
                    border={"none"}
                    fontSize="14px"
                    color={"#27314D"}
                    // value={trainingParams.single_times}
                    textAlign="center"
                    p={0}
                    // onChange={(
                    //   valueAsString: string,
                    //   valueAsNumber: number
                    // ) => handleChangeSingleTimes(valueAsNumber)}
                  >
                    <NumberInputField
                      border={"none"}
                      pr="14px"
                      h="100%"
                      borderRadius={0}
                    />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper
                        border={"none"}
                        fontSize={"10px"}
                      />
                      <NumberDecrementStepper
                        border={"none"}
                        fontSize={"10px"}
                      />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
                <Flex
                  mb={"20px"}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        Multires noise discount
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        多分辨率（金字塔）衰减率
                      </Text>
                    </Box>
                    <Slider
                      flex={1}
                      // value={trainingParams.single_times}
                      step={0.01}
                      min={0}
                      max={1}
                      // onChange={handleChangeSingleTimes}
                    >
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput
                    h="40px"
                    w="100px"
                    step={0.01}
                    max={1}
                    min={0}
                    size="xs"
                    borderRadius={0}
                    bgColor="#EEF1F7"
                    border={"none"}
                    fontSize="14px"
                    color={"#27314D"}
                    // value={trainingParams.single_times}
                    textAlign="center"
                    p={0}
                    // onChange={(
                    //   valueAsString: string,
                    //   valueAsNumber: number
                    // ) => handleChangeSingleTimes(valueAsNumber)}
                  >
                    <NumberInputField
                      border={"none"}
                      pr="14px"
                      h="100%"
                      borderRadius={0}
                    />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper
                        border={"none"}
                        fontSize={"10px"}
                      />
                      <NumberDecrementStepper
                        border={"none"}
                        fontSize={"10px"}
                      />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
              </Box> */}
              <Box ref={anchorRef8}>
                <Box mb="20px" fontSize={"24px"} color="#27314D" fontWeight={500}>
                  其他设置
                </Box>
                <Flex mb={"20px"} alignItems="center">
                  <Box w="240px" mr="15px">
                    <Text fontSize={"13px"} color={"#8E94A9"}>
                      seed
                    </Text>
                    <Text fontSize={"15px"} color="#27314D">
                      随机种子数
                    </Text>
                  </Box>
                  <Input flex={1} borderRadius={0} bgColor="#EEF1F7" h="40px" type="number" border={"none"} fontSize="14px" color={"#27314D"} value={trainingParams.seed} onChange={handleChangeSeed} />
                  <IconButton aria-label="seed" ml="20px" bg="#EEF1F7" icon={<RiColorFilterLine size={"16px"} color={"#27314D"} />} onClick={handleRandomSeed} />
                </Flex>
                <Flex mb={"20px"} alignItems="center" justifyContent={"space-between"}>
                  <Flex flex={1} mr="20px" fontSize="14px">
                    <Box w="240px" mr="15px">
                      <Text fontSize={"13px"} color={"#8E94A9"}>
                        clip skip
                      </Text>
                      <Text fontSize={"15px"} color="#27314D">
                        clip跳过
                      </Text>
                    </Box>
                    <Slider flex={1} value={trainingParams.clip_skip} step={1} min={1} max={2} onChange={handleChangeClipSkip}>
                      <SliderTrack bg="#CBD1DF">
                        <SliderFilledTrack bg="#496AE1" />
                      </SliderTrack>
                      <SliderThumb bg="#496AE1" boxSize={"12px"} />
                    </Slider>
                  </Flex>
                  <NumberInput h="40px" w="100px" step={1} max={2} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={clipSkip} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeClipSkipInput(valueAsNumber)} onBlur={handleChangeClipSkipBlur}>
                    <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                    <NumberInputStepper w="14px">
                      <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                      <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                    </NumberInputStepper>
                  </NumberInput>
                </Flex>
              </Box>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TraingHighSettingModal;
